import React from 'react';
import Logo from './logo';
import * as PropTypes from 'prop-types'

const Logos = ({rows}) => {
  return <div className={'logos-wrapper'}>
    <div className="content">
    {rows.map((row,rowIdx) => {
      return <div className={'row'} key={rowIdx}>
        {row.map((logo,logoIdx) => {
          return <Logo logo={logo} key={logoIdx}/>;
        })}
      </div>;
    })}
    </div>
  </div>
};

Logos.propTypes = {
  rows:PropTypes.array
};

export default Logos;